export const actionTypes = {
  SET_CHILD_INN: 'SET_CHILD_INN',
};

export const setChildInn = function (payload) {
  return {
    type: actionTypes.SET_CHILD_INN,
    payload,
  };
};
